"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptionKey = getOptionKey;
/**
 * Default function to use the unique contact id as a key
 * @param option
 * @returns React.Key
 */
function getOptionKey(option) {
  return option.id;
}
//# sourceMappingURL=getOptionKey.js.map